import styled from "styled-components";
import Div from "../../../common/ui/widgets/division";


export const ProfileModalWrapper = styled(Div)`

.profile-modal{
    z-index: 8;
    font-size: ${(props) => props.theme.font14};
    width: ${(props) => props.theme.width180};
    min-width: max-content;
    height: auto;
    position: absolute;
    right: -9rem;
    top: 56px !important;
    display: block;
    background-color: #ffffff;
    color: #666666;
    border: 1px solid #e6e6e6;
    padding: ${(props) => props.theme.padding12};
    -webkit-box-shadow: 0 2px 2px 0 #ccc;
    box-shadow: 0 2px 2px 0 #cccccc;

}

.profile-modal-header{
    margin-bottom: ${(props) => props.theme.margin10};
    background-color: #ffc20e;
    padding: ${(props) => props.theme.padding6};
    color: #333333 !important;
    div{
        font-size: ${(props) => props.theme.font12};
        font-weight:${(props) => props.theme.fontWeight500};
    }
}

.sub-heading{
    color: #4d4d4d;
    font-size: 10.5px;
    line-height: 1.5em;
    font-weight: ${(props) => props.theme.fontWeight300};
    color: #000000;
    margin: 0;
    padding: 0;
}

.user-options-list {
    position: relative;
    background-color: #ffffff;
    margin: 0;
    padding: 0;
    z-index: 11;
    opacity: ${(props) => props.theme.opacity1};
    visibility: visible;
    color: #000000;
    top: 0;
    left: 0;
    width: ${(props) => props.theme.width100Percentage};
}

.user-options-list-item {
    margin: 0;
    padding: 0;
    list-style: none;
}

.user-options-list-item-link {
    padding: ${(props) => props.theme.padding6};
    display: block;
    color: #333333 !important;
    font-size: ${(props) => props.theme.fontSize14};
    text-decoration: none !important;
    border-left: 4px solid transparent;
    transition: background-color 0.5s;
    transition: font-weight 0.5s;
    &:hover {
        background-color: #f1f1f1;
        border-left: 4px solid #ffc20e;
        font-weight: bold;
        cursor: pointer;
    }
}

@media (max-width: 800px) {
    .profile-modal{
        right: -6rem;
    }
}
@media (max-width: 360px) {
    .profile-modal{
        right: -1rem;
    }
    .logo-wrapper {
        gap: 0;
    }
    .navbar-body {
        margin: 0;
    }
}
`